// WORK ORDER STATUS
export const GET_WORK_ORDER_STATUSES = '/work_order_status/query';
export const GET_WORK_ORDER_STATUS = '/work_order_status/';
export const POST_WORK_ORDER_STATUS = '/work_order_status/';
export const PUT_WORK_ORDER_STATUS = '/work_order_status/';
export const DELETE_WORK_ORDER_STATUS = '/work_order_status/';
export const CHECK_WORK_ORDER_STATUS_EXISTS = '/work_order_status/query';
